import {
  ProgramWizardMetadata,
  ProgramWizardConfig,
  ProgramWizardMessage,
  ProgramTransformerArgs,
} from './types';
import { getProgram } from './program-store';
import { ProgramWizardMessagesStore } from './ProgramWizardMessagesStore';
import {
  CancelOperationError,
  PackageNameEnum,
  ProductNameEnum,
  AppUserProfile,
  ProgramDataType,
  EmptyResponse,
} from '@ssar-app/domain';
import lodashCloneDeep from 'lodash/cloneDeep';
import { useEffect, useRef } from 'react';

export type ProgramFetcherProps = {
  productName: ProductNameEnum;
  packageName: PackageNameEnum;
  programWizardMetadata: ProgramWizardMetadata;
  transformer: ProgramWizardConfig['preTransformer'];
  userProfile: AppUserProfile;
  onSuccess: (
    messages: readonly ProgramWizardMessage[],
    program: Partial<ProgramDataType> | null,
    programDependentData: EmptyResponse,
  ) => void;
  onError: (messages: readonly ProgramWizardMessage[], error: Error) => void;
  onCancel: (messages: readonly ProgramWizardMessage[], reason: string) => void;
};

export const ProgramFetcher = (props: ProgramFetcherProps) => {
  const {
    productName,
    packageName: _packageName,
    transformer,
    userProfile,
    onSuccess,
    onError,
    onCancel,
    programWizardMetadata,
  } = props;

  const messagesStoreRef = useRef(new ProgramWizardMessagesStore());

  useEffect(() => {
    const loadFn = async () => {
      let baseProgram = null;
      if (programWizardMetadata?.from) {
        baseProgram = await getProgram(programWizardMetadata?.from);
      }
      const transformerArgs: ProgramTransformerArgs = {
        program: lodashCloneDeep(baseProgram?.data),
        originalProgram: baseProgram?.data,
        programWizardMetadata,
        userProfile,
        messagesStore: messagesStoreRef.current,
        programWizardDependentData: {},
      };
      const program = await transformer(transformerArgs);
      return program;
    };
    loadFn()
      .then((a) =>
        onSuccess(
          messagesStoreRef.current.getMessages(),
          a?.program,
          a?.programWizardDependentData,
        ),
      )
      .catch((err) => {
        if (err instanceof CancelOperationError) {
          onCancel(messagesStoreRef.current.getMessages(), err.message);
        } else {
          onError(messagesStoreRef.current.getMessages(), err);
        }
      });
  }, [
    onCancel,
    onError,
    onSuccess,
    productName,
    programWizardMetadata,
    transformer,
    userProfile,
  ]);
  return <></>;
};
